import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    createSubscriptionState: {
        subscription: null,
        isloading: "",
        errors: null,
    },
    upgradeSubscriptionState: {
        subscription: null,
        isloading: "",
        errors: null,
    },
    fetchSubscriptionsState: {
        subscriptions: null,
        isloading: "",
        errors: null,
    },
    createPortalSessionState: {
        portal_session: null,
        isloading: "",
        errors: null,
    },
};

export const subscriptionSlice = createSlice({
    name: "subscription",
    initialState,
    reducers: {
        createSubscription: (state) => {
            state.createSubscriptionState.isloading = "processing";
            state.createSubscriptionState.errors = null;
        },
        createSubscriptionSuccess: (state, action) => {
            state.createSubscriptionState.isloading = "success";
            state.createSubscriptionState.subscription = action?.payload;
        },
        createSubscriptionFailed: (state, action) => {
            state.createSubscriptionState.isloading = "failed";
            state.createSubscriptionState.errors = action?.payload;
        },
        upgradeSubscription: (state) => {
            state.upgradeSubscriptionState.isloading = "processing";
            state.upgradeSubscriptionState.errors = null;
        },
        upgradeSubscriptionSuccess: (state, action) => {
            state.upgradeSubscriptionState.isloading = "success";
            state.upgradeSubscriptionState.subscription = action?.payload;
        },
        upgradeSubscriptionFailed: (state, action) => {
            state.upgradeSubscriptionState.isloading = "failed";
            state.upgradeSubscriptionState.errors = action?.payload;
        },
        fetchSubscriptions: (state) => {
            state.fetchSubscriptionsState.isloading = "processing";
            state.fetchSubscriptionsState.subscriptions = null;
            state.fetchSubscriptionsState.errors = null;
        },
        fetchSubscriptionsSuccess: (state, action) => {
            state.fetchSubscriptionsState.isloading = "success";
            state.fetchSubscriptionsState.subscriptions = action?.payload;
        },
        fetchSubscriptionsFailed: (state, action) => {
            state.fetchSubscriptionsState.isloading = "failed";
            state.fetchSubscriptionsState.errors = action?.payload;
        },
        createPortalSession: (state) => {
            state.createPortalSessionState.isloading = "processing";
            state.createPortalSessionState.portal_session = null;
            state.createPortalSessionState.errors = null;
        },
        createPortalSessionSuccess: (state, action) => {
            state.createPortalSessionState.isloading = "success";
            state.createPortalSessionState.portal_session = action?.payload;
        },
        createPortalSessionFailed: (state, action) => {
            state.createPortalSessionState.isloading = "failed";
            state.createPortalSessionState.errors = action?.payload;
        },
        resetCreateUpgradeSubscription: (state) => {
            state.createSubscriptionState.isloading = "";
            state.createSubscriptionState.subscription = null;
            state.createSubscriptionState.errors = null;
            state.upgradeSubscriptionState.isloading = "";
            state.upgradeSubscriptionState.subscription = null;
            state.upgradeSubscriptionState.errors = null;
        },
        resetFetchSubscriptions: (state) => {
            state.fetchSubscriptionsState.isloading = "";
            state.fetchSubscriptionsState.subscription = null;
            state.fetchSubscriptionsState.errors = null;
        },
    },
});

export const {
    createSubscription,
    createSubscriptionSuccess,
    createSubscriptionFailed,
    upgradeSubscription,
    upgradeSubscriptionSuccess,
    upgradeSubscriptionFailed,
    resetCreateUpgradeSubscription,
    fetchSubscriptions,
    fetchSubscriptionsSuccess,
    fetchSubscriptionsFailed,
    createPortalSession,
    createPortalSessionSuccess,
    createPortalSessionFailed,
    resetFetchSubscriptions,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
